import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0a77acc4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logo"
}, null, -1));
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "relation"
}, [/*#__PURE__*/_createElementVNode("label", {
  class: "me-df-text"
}, "7*24小时客服"), /*#__PURE__*/_createElementVNode("span", {
  class: "me-df-text"
}, "400-993-7878")], -1));
const _hoisted_5 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_menu_item = _resolveComponent("a-menu-item");
  const _component_a_sub_menu = _resolveComponent("a-sub-menu");
  const _component_a_menu = _resolveComponent("a-menu");
  const _component_i_drawer = _resolveComponent("i-drawer");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("img", {
    class: "navigation-icon",
    src: _ctx.navigationIcon,
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.openMenuHandle && _ctx.openMenuHandle(...args))
  }, null, 8, _hoisted_5)])]), _createVNode(_component_i_drawer, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[3] || (_cache[3] = $event => _ctx.visible = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_a_menu, {
      class: "menu-content",
      theme: "dark",
      openKeys: _ctx.openKeys,
      "onUpdate:openKeys": _cache[1] || (_cache[1] = $event => _ctx.openKeys = $event),
      selectedKeys: _ctx.selectedKeys,
      "onUpdate:selectedKeys": _cache[2] || (_cache[2] = $event => _ctx.selectedKeys = $event),
      mode: "inline",
      onClick: _ctx.handleClick
    }, {
      default: _withCtx(() => [_createVNode(_component_a_menu_item, {
        key: "home"
      }, {
        default: _withCtx(() => [_createTextVNode(" 首页 ")]),
        _: 1
      }), _createVNode(_component_a_sub_menu, {
        class: "",
        key: "product"
      }, {
        title: _withCtx(() => [_createTextVNode("产品与解决方案")]),
        default: _withCtx(() => [_createVNode(_component_a_menu_item, {
          class: "sub-item",
          key: "freight"
        }, {
          default: _withCtx(() => [_createTextVNode("数字货运")]),
          _: 1
        }), _createVNode(_component_a_sub_menu, {
          key: "link",
          title: "数字供应链"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_menu_item, {
            class: "sub-item",
            key: "coal"
          }, {
            default: _withCtx(() => [_createTextVNode("煤炭行业")]),
            _: 1
          }), _createVNode(_component_a_menu_item, {
            class: "sub-item",
            key: "power"
          }, {
            default: _withCtx(() => [_createTextVNode("电力行业")]),
            _: 1
          }), _createVNode(_component_a_menu_item, {
            class: "sub-item",
            key: "chemical"
          }, {
            default: _withCtx(() => [_createTextVNode("化工行业")]),
            _: 1
          }), _createVNode(_component_a_menu_item, {
            class: "sub-item",
            key: "rail"
          }, {
            default: _withCtx(() => [_createTextVNode("铁路货站")]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_menu_item, {
          class: "sub-item",
          key: "figureEnertgy"
        }, {
          default: _withCtx(() => [_createTextVNode("数字能源")]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_a_menu_item, {
        key: "project"
      }, {
        default: _withCtx(() => [_createTextVNode("客户案例")]),
        _: 1
      }), _createVNode(_component_a_sub_menu, {
        class: "",
        key: "press"
      }, {
        title: _withCtx(() => [_createTextVNode("新闻中心")]),
        default: _withCtx(() => [_createVNode(_component_a_menu_item, {
          key: "companyNews"
        }, {
          default: _withCtx(() => [_createTextVNode("公司新闻")]),
          _: 1
        }), _createVNode(_component_a_menu_item, {
          key: "partyNews"
        }, {
          default: _withCtx(() => [_createTextVNode("党群建设")]),
          _: 1
        }), _createVNode(_component_a_menu_item, {
          key: "enterpriseNews"
        }, {
          default: _withCtx(() => [_createTextVNode("企业文化")]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_a_sub_menu, {
        class: "",
        key: "us"
      }, {
        title: _withCtx(() => [_createTextVNode("关于我们")]),
        default: _withCtx(() => [_createVNode(_component_a_menu_item, {
          class: "sub-item",
          key: "aboutHuoda"
        }, {
          default: _withCtx(() => [_createTextVNode("关于货达")]),
          _: 1
        }), _createVNode(_component_a_menu_item, {
          class: "sub-item",
          key: "joinUs"
        }, {
          default: _withCtx(() => [_createTextVNode("加入我们")]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["openKeys", "selectedKeys", "onClick"])]),
    _: 1
  }, 8, ["visible"])], 64);
}